import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=dbcb831a&scoped=true&"
import script from "./UpdateProfile.vue?vue&type=script&lang=js&"
export * from "./UpdateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcb831a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbcb831a')) {
      api.createRecord('dbcb831a', component.options)
    } else {
      api.reload('dbcb831a', component.options)
    }
    module.hot.accept("./UpdateProfile.vue?vue&type=template&id=dbcb831a&scoped=true&", function () {
      api.rerender('dbcb831a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/Profile/UpdateProfile.vue"
export default component.exports